// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_content-module__container--1rpKy{max-width:1230px;margin:auto;padding-top:10px;padding-bottom:10px}.header_content-module__container--1rpKy:after{content:'';display:block;clear:both}@media screen and (max-width: 79.9375em){.header_content-module__container--1rpKy{max-width:none;width:100%;margin:0;padding-right:25px;padding-left:25px}}@media screen and (max-width: 62.5625em){.header_content-module__container--1rpKy{width:100%;padding-right:25px;padding-left:25px}}@media screen and (max-width: 48em){.header_content-module__container--1rpKy{padding-right:0px;padding-left:0px;margin:auto;width:95%}}\n", ""]);
// Exports
exports.locals = {
	"container": "header_content-module__container--1rpKy"
};
module.exports = exports;
